import { HiDownload } from "react-icons/hi";
import { FiEdit2 } from "react-icons/fi";
import { AiOutlineClose, AiOutlineCheck } from "react-icons/ai";
import { BiPauseCircle } from "react-icons/bi";
import { MdOutlineRemoveCircleOutline } from "react-icons/md";

//YELLOW
export const YellowDownloadIcon = (
  <HiDownload style={{ fontSize: "1.3rem", color: "#E3B221" }} />
);
export const YellowEditIcon = (
  <FiEdit2 style={{ fontSize: "1.3rem", color: "#E3B221" }} />
);
export const YellowCheckIcon = (
  <AiOutlineCheck style={{ fontSize: "1.3rem", color: "#E3B221" }} />
);

//GREY
export const CloseIcon = <AiOutlineClose style={{ fontSize: "1.3rem" }} />;
export const GreyEditIcon = <FiEdit2 style={{ fontSize: "1.3rem" }} />;
export const PauseCircleIcon = <BiPauseCircle style={{ fontSize: "1.3rem" }} />;
export const RemoveCircleOutlineIcon = (
  <MdOutlineRemoveCircleOutline style={{ fontSize: "1.4rem" }} />
);
